import i18n from '@/common/i18n';
import { bytesToUnit } from '@/common/utils/formatter.number';
import { ComputeImage } from '@/common/store/pinia/computeImages/computeImageMapper';

export function imageIconFormatter(row: ComputeImage): string {
  return row.type === 'template' ? 'i-image-template-o--24' : 'i-image-o--24';
}

export function uploadProgressFormatter(loaded = 0, total = 0): string {
  return i18n.t('{loaded} of {total}', {
    loaded: bytesToUnit(loaded, { round: 1 }),
    total: bytesToUnit(total, { round: 1 }),
  });
}

export function imageTypeFormatter(format: string): string {
  return ({
    iso: i18n.t('ISO'),
    ploop: i18n.t('Template (container)'),
  }[format] || i18n.t('Template (VM)'));
}

export default imageIconFormatter;
